import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22theme.ts%22,%22import%22:%22Sora%22,%22arguments%22:[{%22display%22:%22swap%22,%22fallback%22:[%22Helvetica%22,%22Arial%22,%22sans-serif%22],%22subsets%22:[%22latin%22],%22weight%22:[%22300%22,%22400%22,%22500%22,%22600%22,%22700%22]}],%22variableName%22:%22SoraFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Sora', Helvetica, Arial, sans-serif",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
